document.addEventListener('variant:update', (event) => {
  const source = event.detail?.data?.html;
  if (!source) return;
  const nextIdentifiers = source.querySelector('.tm-variant-identifiers');
  const nextBarcode = nextIdentifiers?.querySelector('.barcode');
  const nextSku = nextIdentifiers?.querySelector('.sku');
  const selectedVariantId = nextIdentifiers?.dataset.selectedVariant;
  document.querySelectorAll('.tm-identifiers-wrap').forEach((wrap) => {
    const identifiers = wrap.querySelector('.tm-variant-identifiers');
    const barcode = identifiers?.querySelector('.barcode');
    const sku = identifiers?.querySelector('.sku');
    if (barcode && nextBarcode) barcode.innerHTML = nextBarcode.innerHTML;
    if (sku && nextSku) sku.innerHTML = nextSku.innerHTML;
    if (identifiers && selectedVariantId) identifiers.dataset.selectedVariant = selectedVariantId;
    wrap.querySelectorAll('.tm-variant-overview__row').forEach((row) => row.classList.toggle('is-active', row.dataset.variantId === selectedVariantId));
  });
});
